<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-option-management`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 5a2 2 0 012 2v34a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h38zm-2 4h-4v7.234a1 1 0 01-1.514.857L32 15l-3.485 2.091A1 1 0 0127 16.234V9H7v30h34V9zM22 30a1 1 0 011 1v2a1 1 0 01-1 1H12a1 1 0 01-1-1v-2a1 1 0 011-1h10zm9-8a1 1 0 011 1v2a1 1 0 01-1 1H12a1 1 0 01-1-1v-2a1 1 0 011-1h19z"/></svg>
</template>
<script>

export default {
  name: 'IconOptionManagement',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
